import moment from 'moment';
import {
  GET_COUNTRIES_REQUEST,
  GET_COUNTRIES_SUCCESS,
  GET_COUNTRIES_FAILURE,
  GET_COUNTRIES_CACHED,
  GET_SUBDIVISIONS_REQUEST,
  GET_SUBDIVISIONS_SUCCESS,
  GET_SUBDIVISIONS_FAILURE,
  GET_BIRTH_SUBDIVISIONS_REQUEST,
  GET_BIRTH_SUBDIVISIONS_SUCCESS,
  GET_BIRTH_SUBDIVISIONS_FAILURE,
  GET_MUNICIPALITIES_REQUEST,
  GET_MUNICIPALITIES_SUCCESS,
  GET_MUNICIPALITIES_FAILURE,
  CLEAR_MUNICIPALITIES,
} from '../action/actionTypes';

const initialState = {
  payload: [],
  subdivisions: {},
  birthSubdivisions: {},
  municipalities: {},
  error: '',
  isWaiting: false,
  lastRefresh: null,
};

export default function countries(state = initialState, action) {
  switch (action.type) {
    case GET_COUNTRIES_REQUEST:
      return {
        ...state,
        isWaiting: true,
        error: initialState.error,
      };
    case GET_COUNTRIES_SUCCESS:
      return {
        ...state,
        payload: action.payload,
        isWaiting: false,
        lastRefresh: moment(),
        error: initialState.error,
      };
    case GET_COUNTRIES_FAILURE:
      return {
        ...state,
        error: action.error,
        isWaiting: false,
      };
    case GET_COUNTRIES_CACHED:
      return {
        ...state,
        isWaiting: false,
        error: initialState.error,
      };
    case GET_SUBDIVISIONS_REQUEST:
      return {
        ...state,
        isWaiting: true,
        error: initialState.error,
      };
    case GET_SUBDIVISIONS_SUCCESS:
      return {
        ...state,
        subdivisions: action.payload,
        isWaiting: false,
        error: initialState.error,
      };
    case GET_SUBDIVISIONS_FAILURE:
      return {
        ...state,
        error: action.error,
        isWaiting: false,
      };
    case GET_BIRTH_SUBDIVISIONS_REQUEST:
      return {
        ...state,
        isWaiting: true,
        error: initialState.error,
      };
    case GET_BIRTH_SUBDIVISIONS_SUCCESS:
      return {
        ...state,
        birthSubdivisions: action.payload,
        isWaiting: false,
        error: initialState.error,
      };
    case GET_BIRTH_SUBDIVISIONS_FAILURE:
      return {
        ...state,
        error: action.error,
        isWaiting: false,
      };
    case GET_MUNICIPALITIES_REQUEST:
      // L'elenco viene svuotato subito: se restasse quello della provincia
      // precedente, la select mostrerebbe comuni non pertinenti finche' la
      // risposta non arriva.
      return {
        ...state,
        municipalities: initialState.municipalities,
        isWaiting: true,
        error: initialState.error,
      };
    case GET_MUNICIPALITIES_SUCCESS:
      return {
        ...state,
        municipalities: action.payload,
        isWaiting: false,
        error: initialState.error,
      };
    case GET_MUNICIPALITIES_FAILURE:
      return {
        ...state,
        municipalities: initialState.municipalities,
        error: action.error,
        isWaiting: false,
      };
    case CLEAR_MUNICIPALITIES:
      return {
        ...state,
        municipalities: initialState.municipalities,
        isWaiting: false,
      };
    default:
      return state;
  }
}
